module.exports = __webpack_public_path__ + "static/excluding6-7d25097a03c82743c169d04e988e3684.png";